import Select, { SelectProps } from 'antd/lib/select';
import _, { isEmpty, isNaN, isNil, isNull, noop } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import {
  getChildParList,
  getParList,
  getParListProduct,
  getParListOffer,
} from '../../services/parametersService';
import AddParListValueModal from './AddParListValueModal';
import ModalControllerNV from 'components/ModalControllerNV';
import { Button, Input } from 'antd';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { PlusOutlined } from '@ant-design/icons';

export type ParListSelectProps = SelectProps<any> & {
  parcode: string;
  parvalueparent?: string;
  prcode?: string;
  offerid?: number;
  allowClear?: boolean;
  searchByLabel?: boolean;
  searchByLabelAndValue?: boolean;
  modemultiple?: boolean;
  onSelected?: (val: any) => void;
  onSelectedObj?: (val: any) => void;
  defaultvalue?: string;
  forcedValue?: String;
  allowAddValue?: boolean;
  refetchProps?: boolean;
};

const ParListSelect = (props: ParListSelectProps) => {
  const {
    parcode,
    parvalueparent,
    prcode,
    offerid,
    allowClear,
    modemultiple,
    searchByLabel,
    searchByLabelAndValue,
    defaultvalue,
    onChange = noop,
    onSelected,
    onSelectedObj,
    value,
    forcedValue,
    allowAddValue,
    refetchProps,
    ...rest
  } = props;

  let [init, setInit] = useState(true);


  let ltpid =
    Number(
      isNull(localStorage.getItem('tpid')) ? 0 : localStorage.getItem('tpid')
    ) ?? 0;

  if (isNaN(ltpid)) {
    ltpid = 0;
  }

  const {
    data: parList,
    refetch,
    isLoading,
  } = useQuery(
    ['getParList', { parcode }],
    () =>
      getParList({ parcode: parcode, tpid: ltpid }).then(
        (res) => res.list || []
      ),
    {
      staleTime: MINUTE,
      enabled:
        parvalueparent === undefined && prcode === undefined && isNil(offerid),
    }
  );

  useEffect(() => {
    refetch();
  }, [refetchProps]);

  const { data: parListOffer } = useQuery(
    ['getParListOffer', { parcode, offerid }],
    () =>
      getParListOffer({
        parcode,
        offerid: offerid! ? offerid : ('' as any),
      }).then((res) => res.list || []),
    {
      staleTime: MINUTE,
      enabled: parvalueparent === undefined && !isNil(offerid),
    }
  );

  const { data: parListProduct } = useQuery(
    ['getParListProduct', { parcode, prcode }],
    () =>
      getParListProduct({ parcode, prcode: prcode! }).then(
        (res) => res.list || []
      ),
    {
      staleTime: MINUTE,
      enabled:
        parvalueparent === undefined &&
        prcode !== undefined &&
        offerid === undefined,
    }
  );

  const { data: childParList } = useQuery(
    ['getChildParList', { parcode, parvalueparent }],
    () =>
      getChildParList({ parcode, parvalueparent: parvalueparent! }).then(
        (res) => res.list || []
      ),
    {
      staleTime: MINUTE,
      enabled: parvalueparent !== undefined && parvalueparent !== null,
    }
  );

  const options =
    parvalueparent !== undefined && parvalueparent !== null
      ? childParList
      : !isNil(offerid)
      ? parListOffer
      : prcode !== undefined
      ? parListProduct
      : parList;

  useEffect(() => {
    const defaultParListItem = options?.find(
      ({ parflagdefault }) => parflagdefault
    );
    if (defaultParListItem && value === undefined) {
      if (!allowClear || init) {
        onChange(defaultParListItem?.parvalue, defaultParListItem as any);
        setInit(false);
      }
    }
  }, [options, onChange, value, allowClear]);

  useEffect(() => {
    if (forcedValue) {
      onChange(forcedValue);
    }
  }, [forcedValue]);

  const handleChange = (value: any, option: any) => {
    if (searchByLabel) onChange(option?.key, option);
    else onChange(value, option);
    if (searchByLabelAndValue) onChange(option?.key, option);
    else onChange(value, option);

    if (onSelected) {
      onSelected(value);
    }

    if (onSelectedObj) {
      onSelectedObj(options?.find((ele) => ele.parvalue === value));
    }
  };

  return !modemultiple ? (
    !searchByLabel && !searchByLabelAndValue ? (
      <Input.Group compact>
        <Select
          allowClear={allowClear}
          onChange={handleChange}
          showSearch
          filterOption={(input, option) =>
            option?.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
              0 ||
            option?.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          loading={isLoading}
          value={
            (isNil(value) || value === '') && defaultvalue
              ? defaultvalue
              : value
          }
          style={{ width: '100%' }}
          {...rest}
        >
          {_.orderBy(options, 'parlistlabel', 'asc').map(
            ({ parvalue, parlistlabel }, i) => (
              <Select.Option value={parvalue} key={i}>
                {parlistlabel}
              </Select.Option>
            )
          )}
        </Select>
        {allowAddValue && (
          <ModalControllerNV
            content={({ setVisible, visible }) => (
              <Button
                icon={<PlusOutlined />}
                onClick={() => setVisible(true)}
                size="middle"
              />
            )}
            modal={({ setVisible, visible }) => (
              <AddParListValueModal
                ParcodeParent={parvalueparent ?? ''}
                visible={visible}
                onCancel={() => setVisible(false)}
                onSuccess={() => setVisible(false)}
                title={<GetLabel label="addParListValue" />}
                refetched={false}
                setrefetched={undefined}
                parcode={parcode}
              />
            )}
          ></ModalControllerNV>
        )}
      </Input.Group>
    ) : !searchByLabel ? (
      <Select
        allowClear={allowClear}
        onChange={handleChange}
        showSearch
        loading={isLoading}
        optionFilterProp="children"
        filterOption={(input, option) =>
          option?.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        value={
          options?.find((obj) => obj.parvalue === value)?.parlistlabel ||
          options?.find((obj) => obj.parvalue === value)?.parvalue
        }
        {...rest}
      >
        {_.orderBy(options, 'parlistlabel', 'asc').map(
          ({ parvalue, parlistlabel }, i) => (
            <Select.Option value={parvalue} key={parvalue}>
              {parlistlabel + ' (' + parvalue + ')'}
            </Select.Option>
          )
        )}
      </Select>
    ) : (
      <Select
        allowClear={allowClear}
        onChange={handleChange}
        showSearch
        loading={isLoading}
        value={options?.find((obj) => obj.parvalue === value)?.parlistlabel}
        {...rest}
      >
        {_.orderBy(options, 'parlistlabel', 'asc').map(
          ({ parvalue, parlistlabel }, i) => (
            <Select.Option value={parlistlabel} key={parvalue}>
              {parlistlabel + ' (' + parvalue + ')'}
            </Select.Option>
          )
        )}
      </Select>
    )
  ) : (
    <Select
      allowClear={allowClear}
      onChange={onChange}
      value={!isEmpty(value) ? value.filter((e: any) => e !== '') : []}
      {...rest}
      loading={isLoading}
      mode="multiple"
      placeholder="select one or more"
    >
      {_.orderBy(options, 'parlistlabel', 'asc').map(
        ({ parvalue, parlistlabel }, i) => (
          <Select.Option value={parvalue} key={i}>
            {parlistlabel}
          </Select.Option>
        )
      )}
    </Select>
  );
};

const SECOND = 1000;
const MINUTE = 60 * SECOND;

export default ParListSelect;
